import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { signIn } from "../api/user";
import { encrypt } from "../utils/cryptoHelper";
import { ResetPasswordDialog } from "./ResetPasswordRequestDialog";
import { INTERNAL_ONLY } from "../api";

const LoginView = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [resetDialogOpen, setResetDialogOpen] = useState(false);

  const login = () => {
    signIn(
      username,
      password,
      (user) => {
        window.localStorage.setItem("token", encrypt(JSON.stringify(user)));
        navigate("/modules/projects");
      },
      (error) => {
        const message = error.internal ?? "Username or password incorrect 帳號或密碼錯誤";
        setError(message);
      }
    );
  };

  const forgotPassword = () => {
    setResetDialogOpen(true);
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: "calc(100vh - 64px)",
    alignItems: "center",
    justifyContent: "center",
    px: 16,
    gap: INTERNAL_ONLY ? 2 : 5,
  };

  const boxStyle = {
    width: 400,
    display: "flex",
    flexDirection: "column",
    p: 2,
    alignItems: "center",
    gap: 2,
  };

  const unavailableMessage = (
    <Box>
      <Typography sx={{ color: "#FF0000" }}>
        The web app is under active development and temporarily unavailable for users.
      </Typography>
    </Box>
  );

  return (
    <Box sx={containerStyle}>
      <Box sx={boxStyle}>
        <img width={100} alt="logotext" src="assets/logos/SmartLog.png" />
        <img width={200} alt="logotext" src="assets/logos/smartLogo_text.png" />
      </Box>
      {INTERNAL_ONLY && unavailableMessage}
      <Box sx={boxStyle}>
        <TextField
          label="Username / 帳戶名稱"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
          sx={{ m: 1, width: "100%" }}
        />
        <TextField
          label="Password / 帳戶密碼"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          sx={{ m: 1, width: "100%" }}
          type="password"
        />
        {error && (
          <Typography variant="subtitle1" sx={{ color: "#FF0000" }}>
            {error}
          </Typography>
        )}
      </Box>
      <Box>
        <Typography variant="subtitle1">
          Rock Identification and Rock Core Analysis:{" "}
          <Link href="https://airock.visibleone.io">CIC AI ROCK</Link>
        </Typography>
      </Box>
      <Box sx={boxStyle}>
        <Button
          variant="contained"
          onClick={login}
          sx={{ m: 1, width: "100%" }}
        >
          Login / 登入
        </Button>
        <Button
          variant="outlined"
          onClick={forgotPassword}
          sx={{ width: "100%" }}
        >
          Forgot Password
        </Button>
        <ResetPasswordDialog
          open={resetDialogOpen}
          setOpen={setResetDialogOpen}
          email={undefined}
          username={undefined}
        />
      </Box>
    </Box>
  );
};

export default LoginView;
